import React from "react";
import ErrorPageLayout from "./ErrorPageLayout";
import { ERROR_TYPES, getErrorConfig } from "./errorTypes";

const SessionErrorPage = () => {
  const config = getErrorConfig(ERROR_TYPES.SESSION_IDLE);

  return (
    <ErrorPageLayout
      code={config.code}
      title={config.title}
      message={config.message}
      actionLabel={config.actionLabel}
      actionType={config.actionType}
      showReloadIcon
      variant="session"
    />
  );
};

export default SessionErrorPage;
